import { ResolveFn } from '@angular/router';
import { ApiProductRevision, ApiV1Service } from 'api';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ProductWithAncestors } from 'component/details/product-resolver';

export type RevisionWithAncestors = ApiProductRevision & {
  product: ProductWithAncestors;
};

export const RevisionResolver: ResolveFn<RevisionWithAncestors> = (
  route,
): Observable<RevisionWithAncestors> => {
  return inject(ApiV1Service)
    .getProductRevision(route.params['revisionId'])
    .pipe(
      map((revision) => ({
        ...revision,
        product: route.data['Product'],
      })),
    );
};
